import EventStructuredData from './EventStructuredData';
import { EventItemProps } from '../../content/discover/content';

const EventItem = ({ event, isFourCols }: EventItemProps) => {
  const { date, title, venue, isFree, url, image } = event;
  const dateObj = new Date(date);
  const isValidDate = !!date && !isNaN(dateObj.getTime());
  const month = isValidDate ? dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase() : 'TBD';
  const day = isValidDate ? dateObj.getDate() : '--';

  return (
    <>
      <a href={url} target="_blank" rel="noopener noreferrer" className="block w-full">
        <article className={`flex flex-col w-full max-w-[592px] ${isFourCols ? 'px-3 py-4' : 'px-4 py-6'} rounded-2xl border border-gray-200 bg-white gap-3 md:h-full`}>
          {image && (
            <img src={image} alt={title} className="w-full h-auto object-contain rounded-lg bg-white" />
          )}
          <div>
            <div className="flex items-start gap-4">
              {/* Date */}
              <div className="flex flex-col items-center">
                <span className="flex w-14 justify-center px-4 py-1 rounded-t-lg bg-primary-200 text-gray-800 text-xs font-semibold leading-[18px]">
                  {month}
                </span>
                <span className="flex w-14 justify-center px-4 py-1 rounded-b-lg bg-primary-50 text-gray-950 text-2xl font-normal leading-8">
                  {day}
                </span>
              </div>
              {/* Title */}
              <div className="flex flex-col">
                <h3 className="text-gray-900 text-base font-semibold">{title}</h3>
                {venue && (
                  <p className="text-gray-600 text-sm leading-5 mt-1">{venue}</p>
                )}
                {isFree && (
                  <span className="flex items-center px-[10px] py-[2px] rounded-2xl border border-gray-200 bg-gray-50 mix-blend-multiply w-fit mt-2">
                    <span className="text-gray-700 text-sm font-medium leading-5">Free</span>
                  </span>
                )}
              </div>
            </div>
          </div>
        </article>
      </a>
      <EventStructuredData {...event} />
    </>
  );
};

export default EventItem; 